import request from '@/utils/request'

// 校验 MD5 是否存在
export function checkMd5(md5) {
  return request({
    url: '/file/checkMd5',
    method: 'get',
    params: {md5}
  })
}
